export const GET_DISEASE_SUCCESS = 'GET_DISEASE_SUCCESS'
export const GET_DISEASE_FAIL = 'GET_DISEASE_FAIL'
export const GET_DISEASE_CLEAR_DATA = 'GET_DISEASE_CLEAR_DATA'

export const UPDATE_DISEASE_SUCCESS = 'UPDATE_DISEASE_SUCCESS'
export const UPDATE_DISEASE_FAIL = 'UPDATE_DISEASE_FAIL'
export const UPDATE_DISEASE_CLEAR_DATA = 'UPDATE_DISEASE_CLEAR_DATA'

